<template>
  <div class="container">
    <a-breadcrumb separator=">" class="breadcrumb">
      <a-breadcrumb-item href="" @click.native="() => $router.push('/index')">首页</a-breadcrumb-item>
      <a-breadcrumb-item>申请休假</a-breadcrumb-item>
    </a-breadcrumb>

    <div class="content-box">
      <div class="header-row">
        <a-tabs v-model="activeTab" @change="handleTabChange" class="status-tabs">
          <a-tab-pane key="0">
            <span slot="tab">
              <span class="tab-dot dot-processing"></span>
              进行中
            </span>
          </a-tab-pane>
          <a-tab-pane key="1">
            <span slot="tab">
              <span class="tab-dot dot-success"></span>
              已完成
            </span>
          </a-tab-pane>
          <a-tab-pane key="2">
            <span slot="tab">
              <span class="tab-dot dot-danger"></span>
              已拒绝
            </span>
          </a-tab-pane>
          <a-tab-pane key="-1">
            <span slot="tab">
              <span class="tab-dot dot-muted"></span>
              已取消
            </span>
          </a-tab-pane>
        </a-tabs>

        <a-button type="primary" size="large" class="apply-btn" @click="goToApply">
          <a-icon type="plus" />
          立即申请
        </a-button>
      </div>

      <div class="list-container">
        <div class="list-item" v-for="(item, index) in listData" :key="item.id" @click="goToDetail(item.id)"
          :style="{ animationDelay: index * 0.06 + 's' }">
          <div class="item-left">
            <div class="item-header">
              <span class="name">{{ item.name }}</span>
              <span class="type-tag" :class="'tag-' + item.flowType">
                {{ item.flowType | flowTypeFilter }}
              </span>
            </div>
            <div class="item-meta">
              <div class="meta-row">
                <a-icon type="clock-circle" class="meta-icon" />
                <span>申请时间：{{ item.createTime | dateToYMDFilter }}</span>
              </div>
              <div class="meta-row refuse" v-if="activeTab == 2 && item.fbkStatus == 2">
                <a-icon type="close-circle" class="meta-icon" />
                <span>防保科拒绝原因：{{ item.fbkRefuseReason }}</span>
              </div>
              <div class="meta-row refuse" v-if="activeTab == 2 && item.yldStatus == 2">
                <a-icon type="close-circle" class="meta-icon" />
                <span>院领导拒绝原因：{{ item.yldRefuseReason }}</span>
              </div>
            </div>
          </div>

          <div class="item-right">
            <a-button v-if="activeTab == '0'" type="danger" size="small" ghost @click.stop="cancelApply(item)">
              取消申请
            </a-button>
            <a-button v-if="activeTab == '1'" type="primary" size="small" ghost @click.stop="downloadPDF(item)">
              <a-icon type="download" />
              下载PDF
            </a-button>
            <a-button v-if="activeTab == '2'" type="primary" size="small" ghost @click.stop="goToEdit(item)">
              <a-icon type="edit" />
              补充资料
            </a-button>
            <a-icon type="right" class="arrow-icon" />
          </div>
        </div>

        <div v-if="listData.length === 0 && !loading" class="empty-state">
          <a-icon type="inbox" class="empty-icon" />
          <p class="empty-text">暂无数据</p>
        </div>

        <div v-if="loading" class="loading-container">
          <a-spin size="large" />
        </div>
      </div>
    </div>

    <a-modal title="下载PDF" :visible="emailModalVisible" :confirm-loading="modalLoading" @ok="handleEmailOk"
      @cancel="handleEmailCancel" okText="发送" cancelText="取消">
      <a-form :form="emailForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-item label="邮箱地址">
          <a-input v-decorator="[
            'email',
            {
              initialValue: defaultEmail,
              rules: [
                { required: true, message: '请输入邮箱地址' },
                { pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: '请输入正确的邮箱格式' }
              ]
            }
          ]" placeholder="请输入邮箱地址" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import {
  getFlowId,
  getFlowList,
  cancelFlow,
  sendEmail
} from "@/api/sickLeave";

export default {
  data() {
    return {
      activeTab: "0",
      listData: [],
      loading: false,
      userInfo: {},
      emailModalVisible: false,
      modalLoading: false,
      currentItem: null,
      defaultEmail: "",
      emailForm: this.$form.createForm(this)
    };
  },
  created() {
    this.userInfo =
      sessionStorage.getItem("userInfo") &&
      JSON.parse(sessionStorage.getItem("userInfo"));
    this.defaultEmail = this.userInfo.email || "";
    this.getList();
    this.getFlowId();
  },
  methods: {
    handleTabChange() {
      this.getList();
    },
    async getFlowId() {
      try {
        const { code, data } = await getFlowId();
        if (code == 200) {
          let flowIdList = data.records || [];
          if (flowIdList.length > 0) {
            this.flowId = flowIdList[0].processDefinitionId
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getList() {
      this.loading = true;
      try {
        const params = {
          finishStatus: Number(this.activeTab)
        };
        const { code, data } = await getFlowList(params);
        if (code == 200) {
          this.listData = data || [];
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    goToApply() {
      if (!this.flowId) {
        this.$message.error("流程id不存在,请从首页重新进入");
        return;
      }
      this.$router.push({ path: "/sick-leave-add", query: { id: this.flowId } });
    },
    goToDetail(id) {
      this.$router.push({ path: "/sick-leave-detail", query: { id ,flowId: this.flowId} });
    },
    goToEdit(item) {
      this.$router.push({ path: "/sick-leave-add", query: { flowNo: item.id, id: this.flowId} });
    },
    async cancelApply(item) {
      const _self = this;
      this.$confirm({
        title: "确认取消申请？",
        content: "取消后无法恢复，请确认",
        async onOk() {
          try {
            const params = {
              id: item.id
            };
            const { code } = await cancelFlow(params);
            if (code == 200) {
              _self.$message.success("取消成功");
              _self.getList();
            }
          } catch (error) {
            console.error(error);
          }
        },
        async onCancel() { }
      });
    },
    downloadPDF(item) {
      this.currentItem = item;
      this.defaultEmail = this.userInfo.email || "";
      this.$nextTick(() => {
        this.emailForm.setFieldsValue({ email: this.defaultEmail });
      });
      this.emailModalVisible = true;
    },
    handleEmailOk() {
      this.emailForm.validateFields(async (err, values) => {
        if (!err) {
          this.modalLoading = true;
          try {
            const params = {
              type: this.currentItem.flowType, //申请单类型
              formId: this.currentItem.id, //编号
              formName:
                "浙江大学" + this.flowTypeFilter(this.currentItem.flowType) + "申请表", //表名
              email: values.email
            };
            const { code } = await sendEmail(params);
            if (code == 200) {
              this.$message.success("申请表已发送至您的邮箱,请注意查收!");
              this.emailModalVisible = false;
            }
          } catch (error) {
            console.error(error);
          } finally {
            this.modalLoading = false;
          }
        }
      });
    },
    handleEmailCancel() {
      this.emailModalVisible = false;
      this.currentItem = null;
    },
    // 申请类型过滤器 1-休学 2-复学 3-请假 4-缓考
    flowTypeFilter(v) {
      if (v == 1) {
        return "休学";
      } else if (v == 2) {
        return "复学";
      } else if (v == 3) {
        return "请假";
      } else if (v == 4) {
        return "缓考";
      } else {
        return "";
      }
    },
  }
};
</script>

<style lang="scss" scoped>
$primary: #3b82f6;
$primary-light: #eff6ff;
$danger: #ef4444;
$danger-light: #fef2f2;
$success: #10b981;
$success-light: #ecfdf5;
$warning: #f59e0b;
$text-primary: #1e293b;
$text-secondary: #64748b;
$text-muted: #94a3b8;
$border: #e2e8f0;
$surface: #ffffff;
$bg: #f1f5f9;
$shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.04);
$shadow-md: 0 4px 16px rgba(0, 0, 0, 0.06);
$shadow-lg: 0 8px 32px rgba(0, 0, 0, 0.08);
$radius: 12px;

.container {
  min-height: 100vh;
  padding: 24px;
  background: $bg;
  border-radius: $radius;
}

.breadcrumb {
  margin: 0 auto 16px;
  padding: 0 4px;
}

.content-box {
  margin: 0 auto;
  background: $surface;
  padding: 28px 32px 36px;
  border-radius: $radius;
  box-shadow: $shadow-md;
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 28px;
}

.status-tabs {
  flex: 1;

  /deep/ .ant-tabs-bar {
    margin: 0;
    border-bottom: none;
  }

  /deep/ .ant-tabs-tab {
    padding: 8px 0;
    margin: 0 20px 0 0;
    font-size: 14px;
    font-weight: 500;
    color: $text-muted;
    transition: color 0.25s ease;

    &:hover {
      color: $text-secondary;
    }
  }

  /deep/ .ant-tabs-tab-active {
    color: $primary !important;
  }

  /deep/ .ant-tabs-ink-bar {
    background: $primary;
    height: 3px;
    border-radius: 3px;
  }
}

.tab-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin-right: 6px;
  vertical-align: middle;
  position: relative;
  top: -1px;

  &.dot-processing {
    background: $primary;
    box-shadow: 0 0 0 3px rgba($primary, 0.2);
  }

  &.dot-success {
    background: $success;
    box-shadow: 0 0 0 3px rgba($success, 0.2);
  }

  &.dot-danger {
    background: $danger;
    box-shadow: 0 0 0 3px rgba($danger, 0.2);
  }

  &.dot-muted {
    background: $text-muted;
    box-shadow: 0 0 0 3px rgba($text-muted, 0.15);
  }
}

.apply-btn {
  flex-shrink: 0;
  height: 40px;
  border-radius: 8px;
  font-weight: 600;
  letter-spacing: 0.3px;
  box-shadow: 0 2px 8px rgba($primary, 0.35);
  transition: all 0.25s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 14px rgba($primary, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
}

.list-container {
  min-height: 200px;
}

.list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid $border;
  border-radius: 10px;
  padding: 20px 24px;
  margin-bottom: 14px;
  cursor: pointer;
  background: $surface;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0;
  animation: slideUp 0.4s ease forwards;

  &:hover {
    border-color: rgba($primary, 0.35);
    box-shadow: $shadow-lg;
    transform: translateY(-2px);

    .arrow-icon {
      opacity: 1;
      transform: translateX(0);
      color: $primary;
    }
  }

  &:active {
    transform: translateY(0);
    box-shadow: $shadow-md;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(12px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.item-left {
  flex: 1;
  min-width: 0;
}

.item-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;

  .name {
    font-size: 16px;
    font-weight: 600;
    color: $text-primary;
    letter-spacing: 0.2px;
  }
}

.type-tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.3px;
  flex-shrink: 0;
}

.tag-0,
.tag-1,
.tag-2 {
  background: $primary-light;
  color: $primary;
}

.item-meta {
  .meta-row {
    display: flex;
    align-items: flex-start;
    font-size: 13px;
    margin-bottom: 4px;
    color: $text-secondary;
    line-height: 1.7;

    &.refuse {
      color: $danger;
      font-weight: 500;
    }
  }

  .meta-icon {
    margin-right: 8px;
    font-size: 13px;
    color: $text-muted;
    line-height: 1.7;
    flex-shrink: 0;

    .refuse & {
      color: $danger;
    }
  }
}

.item-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  margin-left: 24px;

  .ant-btn {
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.2s ease;

    &:hover {
      transform: translateY(-1px);
    }
  }
}

.arrow-icon {
  font-size: 14px;
  color: $text-muted;
  opacity: 0;
  transform: translateX(-6px);
  transition: all 0.3s ease;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 0;

  .empty-icon {
    font-size: 56px;
    color: $border;
    margin-bottom: 16px;
  }

  .empty-text {
    font-size: 14px;
    color: $text-muted;
    letter-spacing: 0.5px;
  }
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 80px 0;
}

@media (max-width: 640px) {
  .container {
    padding: 12px;
  }

  .content-box {
    padding: 20px 16px 28px;
  }

  .header-row {
    flex-direction: column;
    gap: 16px;
  }

  .apply-btn {
    align-self: flex-end;
  }

  .list-item {
    flex-direction: column;
    align-items: flex-start;
    padding: 16px;
  }

  .item-right {
    margin-left: 0;
    margin-top: 14px;
    width: 100%;
    justify-content: flex-end;
  }

  .arrow-icon {
    display: none;
  }
}
</style>